export default __webpack_public_path__ + "static/media/complementary--pedestrians-left--g1.b56a5492.png";